<div #toastOutlet></div>

<div class="flex">
  <div class="flex min-h-0 flex-col w-full lg:p-11 p-6 card">
    <div class="flex justify-between mb-4">
      <p class="lg:text-4xl text-2xl font-bold">Create Test Set</p>
    </div>
    <form (submit)="handleSubmit($event)">
      @if (isLoading()) {
      <div class="flex items-center justify-center h-full">
        <span class="loading loading-dots loading-lg"></span>
      </div>
      } @else {
      <div class="flex flex-col lg:flex-row lg:gap-6 gap-1.5">
        <div class="flex flex-col flex-1 gap-1.5">
          <!-- Test Set Name -->
          <div class="flex-col w-full">
            <div class="flex">
              <legend class="fieldset-legend">
                Test Set Name<sup class="text-red-500">*</sup>
              </legend>
            </div>
            <input
              data-testid="test-set-name-input"
              name="testSetName"
              type="text"
              class="w-full input placeholder-gray-300 rounded-lg"
              placeholder="Enter Test Set Name"
              (keydown.enter)="$event.preventDefault()"
              required />
          </div>

          <!-- Test Set Difficulty -->
          <div class="flex-col w-full">
            <div class="flex">
              <legend class="fieldset-legend">
                Pick Difficulty of Problems<sup class="text-red-500">*</sup>
              </legend>
            </div>
            <app-select
              id="difficulty-selector"
              name="difficulty-selector"
              [items]="selectItems()"
              [(selectedItem)]="selectedDifficulty" />
          </div>
        </div>

        <div class="flex flex-col flex-1">
          <!-- Test Set Description -->
          <div class="flex-col w-full h-full">
            <div class="flex">
              <legend class="fieldset-legend">
                Test Set Description<sup class="text-red-500">*</sup>
              </legend>
            </div>
            <textarea
              name="testSetDescription"
              class="w-full textarea placeholder-gray-300 rounded-lg min-h-35"
              placeholder="Enter Test Set Description"
              (keydown.enter)="$event.preventDefault()"
              required></textarea>
          </div>
        </div>
      </div>

      <div class="lg:pt-12 pt-6">
        <p
          class="text-xl lg:text-2xl font-semibold text-black mb-3"
          id="problems-heading">
          Problems
        </p>
      </div>

      <div class="flex flex-col space-y-4">
        @for(item of selectedProblems(); track item.problemId) {
        <!-- problems item -->
        <div
          class="flex flex-row justify-between gap-3.5 w-full"
          id="problem-item">
          <div class="flex-19/20">
            <app-item
              [title]="item.title"
              [description]="item.description"
              [difficulty]="item.difficulty"
              [duration]="item.duration" />
          </div>
          <div class="flex-1/20 flex justify-center items-center">
            <button
              type="button"
              class="hover:cursor-pointer"
              id="delete-problem-button"
              (click)="handleDeleteProblem(item.problemId)">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M25.3327 2.66797H6.66602C4.45688 2.66797 2.66602 4.45883 2.66602 6.66797V9.33464C2.66602 10.071 3.26297 10.668 3.99935 10.668H5.33268V25.3346C5.33268 27.5438 7.12354 29.3346 9.33268 29.3346H22.666C24.8752 29.3346 26.666 27.5438 26.666 25.3346V10.668H27.9993C28.7357 10.668 29.3327 10.071 29.3327 9.33464V6.66797C29.3327 4.45883 27.5418 2.66797 25.3327 2.66797ZM23.9993 25.3346C23.9993 26.071 23.4024 26.668 22.666 26.668H9.33268C8.5963 26.668 7.99935 26.071 7.99935 25.3346V10.668H23.9993V25.3346ZM5.33268 8.0013H26.666V6.66797C26.666 5.93159 26.0691 5.33464 25.3327 5.33464H6.66602C5.92964 5.33464 5.33268 5.93159 5.33268 6.66797V8.0013ZM10.666 22.668V14.668C10.666 13.9316 11.263 13.3346 11.9993 13.3346C12.7357 13.3346 13.3327 13.9316 13.3327 14.668V22.668C13.3327 23.4043 12.7357 24.0013 11.9993 24.0013C11.263 24.0013 10.666 23.4043 10.666 22.668ZM18.666 14.668V22.668C18.666 23.4043 19.263 24.0013 19.9993 24.0013C20.7357 24.0013 21.3327 23.4043 21.3327 22.668V14.668C21.3327 13.9316 20.7357 13.3346 19.9993 13.3346C19.263 13.3346 18.666 13.9316 18.666 14.668Z"
                  fill="#FB2C36" />
              </svg>
            </button>
          </div>
        </div>
        }
        <button
          type="button"
          class="border-dashed border border-primary rounded-xl hover:cursor-pointer h-[131px] text-primary flex items-center justify-center text-lg font-semibold"
          (click)="openProblemModal()">
          + Add Problem
        </button>
      </div>

      <div class="mt-5 flex flex-row justify-end gap-3.5">
        <div class="w-fit">
          <app-button type="button" label="Cancel" routerLink="/test-sets" />
        </div>
        <div class="w-fit">
          <app-button color="primary" type="submit" label="Create" />
        </div>
      </div>
      }
    </form>
  </div>
</div>

<app-problem-modal
  [showProblemModal]="showProblemModal()"
  [problems]="allProblems()"
  (closed)="onProblemModalClosed()"
  (AddProblem)="onProblemsAdded($event)" />
